import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styled, { keyframes, css } from 'styled-components';
import { useTranslation } from '../translations';
import logo from '../assets/the.rENT_footer.jpg';
import { wyloguj } from '../utils/wyloguj';
import { stanPrzyciskuMenu } from '../utils/przyciskMenu';
import PremiumBadge from './premium/PremiumBadge';
import { usePremiumUpgrade } from './premium/PremiumUpgrade';

// SVG Icons - nowoczesne i spójne
const HomeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const ChartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="12" y1="20" x2="12" y2="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="18" y1="20" x2="18" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="6" y1="20" x2="6" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const UsersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BoxIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M21 16V8a2 2 0 0 0-1-1.73L12 2 4 6.27A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73L12 22l8-4.27A2 2 0 0 0 21 16z" stroke="currentColor" strokeWidth="2"/>
    <polyline points="3.27,6.96 12,12.01 20.73,6.96" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="12" y1="22.08" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const PlusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
    <line x1="12" y1="8" x2="12" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="8" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const BellIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
  </svg>
);
const InvoiceIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="9" y1="13" x2="15" y2="13"/>
    <line x1="9" y1="17" x2="15" y2="17"/>
    <text x="12" y="11" textAnchor="middle" fontSize="6" fontWeight="bold" fill="currentColor" stroke="none">FV</text>
  </svg>
);
const DocumentIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="14,2 14,8 20,8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <polyline points="10,9 9,9 8,9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const BanknoteIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="12" rx="2"/>
    <circle cx="12" cy="12" r="2.5"/>
    <line x1="5.5" y1="12" x2="5.51" y2="12"/>
    <line x1="18.5" y1="12" x2="18.51" y2="12"/>
  </svg>
);
const CreditCardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2"/>
    <line x1="2" y1="10" x2="22" y2="10"/>
  </svg>
);
const TagIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
    <line x1="7" y1="7" x2="7.01" y2="7"/>
  </svg>
);
const SendIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);
const CodeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"/>
    <polyline points="8 6 2 12 8 18"/>
  </svg>
);

const SettingsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 1v6m0 6v6m9.66-9.66l-5.2 3M7.54 14.66l-5.2 3m15.32 0l-5.2-3m-5.2 3l-5.2-3m15.32-5.32l-5.2 3m-5.2-3l-5.2-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const LogoutIconSVG = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="16,17 21,12 16,7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const CollapseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="15,18 9,12 15,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MenuIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Animacje
const slideIn = keyframes`
  from { opacity: 0; transform: translateX(-10px); }
  to { opacity: 1; transform: translateX(0); }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

// Styled Components
const SidebarContainer = styled.div`
  width: ${props => props.isCollapsed ? '72px' : '240px'};
  height: 100vh;
  /* 100vh na telefonie to wysokosc BEZ dolnego paska przegladarki, wiec panel byl wyzszy niz
     widoczny obszar i przycisk wylogowania chowal sie pod paskiem adresu. W aplikacji dodanej do
     ekranu glownego problem nie wystepowal, dlatego umknal. dvh uwzglednia chowajacy sie pasek;
     100vh zostaje jako zapas dla starszych przegladarek. Zgloszone przez Piotrka 2026-08-15. */
  height: 100dvh;
  /* Plaskie tlo zamiast przejscia z #1e293b do #334155. Menu widac na kazdym ekranie,
     wiec to ono najmocniej niesie wrazenie calosci. Jednolita ciemna plaszczyzna czyta
     sie jako tlo, gradient jako ozdoba. */
  background: var(--sidebar-bg);
  position: fixed;
  left: 0;
  top: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: var(--z-sidebar);
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--sidebar-border);
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);
  /* Odstep na wciecie z lewej (telefon obrocony) i na kreske gestu u dolu, inaczej
     „Wyloguj" na koncu listy trafia dokladnie pod kreske. Tlo nadal siega krawedzi
     ekranu, bo odsuwana jest TRESC, nie plaszczyzna: przy box-sizing: border-box
     padding zjada szerokosc wewnetrzna, a ciemny prostokat zostaje pelny. */
  padding-left: var(--safe-left);
  padding-bottom: var(--safe-bottom);

  @media (max-width: 768px) {
    width: 240px;
    transform: ${props => props.isCollapsed ? 'translateX(-100%)' : 'translateX(0)'};
    box-shadow: ${props => props.isCollapsed ? 'none' : '8px 0 32px rgba(0, 0, 0, 0.3)'};
    overflow: hidden;
  }
`;

const SidebarHeader = styled.div`
  padding: 24px 20px;
  border-bottom: 1px solid var(--sidebar-border);
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  position: relative;
  min-height: auto;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  opacity: ${props => props.isCollapsed ? 0 : 1};
  transform: translateX(${props => props.isCollapsed ? '-20px' : '0'});
  transition: all 0.3s ease;
  pointer-events: ${props => props.isCollapsed ? 'none' : 'auto'};
`;

const LogoIcon = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
  min-width: 32px;
  flex-shrink: 0;
`;

const LogoText = styled.div`
  color: #f1f5f9;
  font-weight: 700;
  font-size: 1.1rem;
  white-space: nowrap;
  letter-spacing: -0.025em;
`;

// width/min-width: nagłówek ma align-items: flex-start, więc bez tego kontener
// rozciąga się do szerokości tekstu i wychodzi poza sidebar — a ellipsis/zawijanie
// w dzieciach nigdy nie ma czego przyciąć.
const UserContextInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
  opacity: ${props => props.isCollapsed ? 0 : 1};
  transform: translateX(${props => props.isCollapsed ? '-20px' : '0'});
  transition: all 0.3s ease;
  pointer-events: ${props => props.isCollapsed ? 'none' : 'auto'};
  margin-top: ${props => props.isCollapsed ? '0' : '16px'};
  padding-top: ${props => props.isCollapsed ? '0' : '12px'};
  border-top: ${props => props.isCollapsed ? 'none' : '1px solid rgba(148, 163, 184, 0.2)'};
  /* Po zwinięciu blok jest tylko przezroczysty, więc nadal zajmowałby miejsce —
     przy zawijanym tekście na szerokości 72px urósłby na kilka linii i zepchnął
     menu w dół. Zerowa wysokość zdejmuje go z układu, opacity dalej się animuje. */
  height: ${props => props.isCollapsed ? '0' : 'auto'};
  overflow: ${props => props.isCollapsed ? 'hidden' : 'visible'};
`;

// Długa nazwa organizacji/użytkownika zawija się do kolejnych linii zamiast wychodzić
// poza sidebar. `overflow-wrap: anywhere` łamie też pojedyncze długie słowo (nazwa
// bez spacji, adres e-mail) — samo `word-break: break-word` zostawiłoby je w całości.
const wrappingText = `
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
  line-height: 1.35;
`;

const OrganizationName = styled.div`
  color: #cbd5e1;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  ${wrappingText}
`;

const UserName = styled.div`
  color: #94a3b8;
  font-size: 0.75rem;
  ${wrappingText}
`;

const CollapseButton = styled.button`
  width: 32px;
  height: 32px;
  background: rgba(248, 250, 252, 0.1);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 8px;
  color: #cbd5e1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  transform: ${props => props.isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)'};
  position: absolute;
  top: 24px;
  right: 20px;
  z-index: var(--z-dropdown);

  &:hover {
    background: rgba(248, 250, 252, 0.2);
    border-color: rgba(59, 130, 246, 0.4);
    color: #3b82f6;
    transform: ${props => props.isCollapsed ? 'rotate(180deg) scale(1.1)' : 'rotate(0deg) scale(1.1)'};
  }

`;

// Floating hamburger button na mobile — pokazywany tylko gdy sidebar zamkniety
const MobileToggleFab = styled.button`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    position: fixed;
    /* Jedyny sposob otwarcia menu na telefonie, wiec nie moze wejsc pod wciecie. */
    top: calc(12px + var(--safe-top));
    left: calc(12px + var(--safe-left));
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    background: rgba(30, 41, 59, 0.55);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(148, 163, 184, 0.3);
    border-radius: 10px;
    color: #f1f5f9;
    box-shadow: var(--shadow-sm);
    cursor: pointer;
    z-index: calc(var(--z-sidebar) + 2);
    transition: all 0.2s ease;

    &:hover {
      background: rgba(30, 41, 59, 0.85);
      border-color: rgba(59, 130, 246, 0.6);
    }

    /* Nad przewiniętą treścią pełne tło: półprzezroczysty przycisk mieszał się z tekstem pod
       spodem (utils/przyciskMenu.js). */
    &[data-nad-trescia='true'] {
      background: #1e293b;
    }

    /* Schowany przy przewijaniu w dół; fokus z klawiatury pokazuje go z powrotem. */
    &[data-ukryty='true']:not(:focus-visible) {
      transform: translateY(calc(-100% - 12px - var(--safe-top)));
      opacity: 0;
      pointer-events: none;
    }
  }
`;

const NavSection = styled.div`
  flex: 1;
  padding: 20px 0;
  overflow-y: auto;
  overflow-x: hidden;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.3);
    border-radius: 2px;
  }
`;

const NavGroup = styled.div`
  margin-bottom: 8px;
`;

const NavGroupLabel = styled.div`
  padding: 8px 20px 12px 20px;
  color: #94a3b8;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: ${props => props.isCollapsed ? 0 : 1};
  transition: opacity 0.3s ease;
`;

const NavItem = styled(NavLink)`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin: 2px 12px;
  color: #cbd5e1;
  text-decoration: none;
  border-radius: 12px;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  position: relative;
  animation: ${slideIn} 0.3s ease-out;
  
  &:hover {
    background: rgba(59, 130, 246, 0.1);
    color: #60a5fa;
    transform: translateX(4px);
  }
  
  &.active {
    /* Bylo przejscie z niebieskiego w fiolet. Aktywna pozycje wskazuje juz pasek po lewej
       i kolor tekstu, wiec tlo ma ja tylko delikatnie podniesc, nie konkurowac. */
    background: rgba(59, 130, 246, 0.16);
    color: #60a5fa;
    border-left: 3px solid #3b82f6;
    margin-left: 9px;
    
    /* Kropka tylko gdy sidebar nie jest zwinięty */
    &::before {
      content: '';
      position: absolute;
      right: 12px;
      width: 6px;
      height: 6px;
      background: #3b82f6;
      border-radius: 50%;
      animation: ${pulse} 2s infinite;
      opacity: ${props => props.isCollapsed ? 0 : 1};
      transition: opacity 0.3s ease;
    }
  }
`;

// Funkcja premium poza planem firmy (F.2): pozycja zostaje w menu z plakietką, ale nie prowadzi do
// strony; kliknięcie otwiera „Chcę Premium”. Rozszerza NavItem, więc ma jego klasę (podpowiedź
// przy zwiniętym menu działa tak samo).
const NavLockedButton = styled(NavItem).attrs({ as: 'button', type: 'button' })`
  width: calc(100% - 24px);
  background: transparent;
  border: none;
  font: inherit;
  font-weight: 500;
  font-size: 0.875rem;
  text-align: left;
  cursor: pointer;
  color: #94a3b8;
`;

const NavBadgeSlot = styled.span`
  margin-left: auto;
  padding-left: 8px;
  display: ${props => props.isCollapsed ? 'none' : 'inline-flex'};
`;

const NavIcon = styled.div`
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${props => props.isCollapsed ? '0' : '12px'};
  color: inherit;
`;

const NavText = styled.span`
  opacity: ${props => props.isCollapsed ? 0 : 1};
  transform: translateX(${props => props.isCollapsed ? '-10px' : '0'});
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
`;

const Tooltip = styled.div`
  position: absolute;
  left: 72px;
  background: #1f2937;
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transform: translateX(-8px);
  transition: all 0.2s ease;
  z-index: calc(var(--z-sidebar) + 1);
  box-shadow: var(--shadow-sm);
  
  &::before {
    content: '';
    position: absolute;
    left: -4px;
    top: 50%;
    transform: translateY(-50%);
    border: 4px solid transparent;
    border-right-color: #1f2937;
  }
  
  ${NavItem}:hover & {
    opacity: ${props => props.isCollapsed ? 1 : 0};
    transform: translateX(0);
  }
`;

const SidebarFooter = styled.div`
  padding: 20px;
  border-top: 1px solid var(--sidebar-border);
`;

const LogoutButton = styled.button`
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;              // ikona/tekst zawsze centrowane
  padding: 12px 16px;
  gap: ${props => props.isCollapsed ? '0' : '12px'};  // odstęp tylko przy rozwiniętym
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 12px;
  color: #fca5a5;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  line-height: 0;                        // brak przesunięć baseline

  &:hover {
    background: rgba(239, 68, 68, 0.2);
    border-color: rgba(239, 68, 68, 0.4);
    color: #ef4444;
    transform: translateY(-1px);
  }
`;

const LogoutIconContainer = styled.div`
  width: 20px;                            // stały wymiar
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;                                        // brak margin-right — używamy gap

const LogoutText = styled.span`
  display: ${props => props.isCollapsed ? 'none' : 'inline'};  // całkiem ukryj w trybie collapsed
  color: inherit;
  transition: opacity 0.3s ease, transform 0.3s ease;
`;

const LogoutTooltip = styled.div`
  position: absolute;
  left: 72px;
  top: 50%;
  transform: translateY(-50%);
  background: #1f2937;
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s ease;
  z-index: calc(var(--z-sidebar) + 1);
  box-shadow: var(--shadow-sm);
  
  &::before {
    content: '';
    position: absolute;
    left: -4px;
    top: 50%;
    transform: translateY(-50%);
    border: 4px solid transparent;
    border-right-color: #1f2937;
  }
  
  ${LogoutButton}:hover & {
    opacity: ${props => props.isCollapsed ? 1 : 0};
  }
`;

// Overlay dla mobile - zamyka sidebar po kliknięciu poza nim
const MobileOverlay = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: ${props => props.show && !props.isCollapsed ? 'block' : 'none'};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: calc(var(--z-sidebar) - 1);
    backdrop-filter: blur(4px);
  }
`;

export default function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    // Auto-collapse na mobile przy starcie
    return window.innerWidth <= 768;
  });
  const { t } = useTranslation();
  const location = useLocation();

  // Reaguj na zmianę rozmiaru okna
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768 && !isCollapsed) {
        setIsCollapsed(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isCollapsed]);

  // Przycisk menu na telefonie chowa się przy przewijaniu w dół i wraca przy przewijaniu w górę
  // (utils/przyciskMenu.js, test na iPhonie 17). Przewija się #root (index.css), a zdarzenie
  // `scroll` nie bubbluje, więc nasłuch jest w fazie przechwytywania na dokumencie.
  const [przyciskMenu, setPrzyciskMenu] = useState({ ukryty: false, nadTrescia: false });
  useEffect(() => {
    let stan = { ukryty: false, nadTrescia: false, kotwica: 0 };
    const naPrzewiniecie = (e) => {
      const cel = e.target === document ? document.scrollingElement : e.target;
      if (!cel || (cel.id !== 'root' && cel !== document.scrollingElement)) return;
      const nowy = stanPrzyciskuMenu({ ...stan, top: cel.scrollTop });
      if (nowy.ukryty !== stan.ukryty || nowy.nadTrescia !== stan.nadTrescia) {
        setPrzyciskMenu({ ukryty: nowy.ukryty, nadTrescia: nowy.nadTrescia });
      }
      stan = nowy;
    };
    document.addEventListener('scroll', naPrzewiniecie, { capture: true, passive: true });
    return () => document.removeEventListener('scroll', naPrzewiniecie, { capture: true });
  }, []);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const logout = wyloguj;

  // Publikuj szerokość sidebara jako zmienną CSS dla layoutu stron
  useEffect(() => {
    const width = isCollapsed ? '72px' : '240px';
    document.documentElement.style.setProperty('--sidebar-width', width);
  }, [isCollapsed]);

  // Sprawdź czy użytkownik jest Super-Adminem / Adminem
  const isSuperAdmin = localStorage.getItem('isSuperAdmin') === '1';
  const isAdmin = localStorage.getItem('isAdmin') === '1' || isSuperAdmin;
  const subscriptionPlan = localStorage.getItem('subscriptionPlan') || 'basic';
  
  // Pobierz dane użytkownika i organizacji
  const organizationName = localStorage.getItem('organizationName') || '';
  const userFirstName = localStorage.getItem('userFirstName') || '';
  const userLastName = localStorage.getItem('userLastName') || '';
  const userFullName = userFirstName && userLastName ? `${userFirstName} ${userLastName}` : userFirstName;
  
  // Widget dostępny dla super-adminów lub adminów z planem premium
  const hasWidgetAccess = isSuperAdmin || (isAdmin && subscriptionPlan === 'premium');
  // F.2: administrator firmy spoza Premium widzi Widget zablokowany, nie znika on z menu.
  const otworzChcePremium = usePremiumUpgrade();

  const navigationItems = [
    { 
      group: 'sidebar.group.main',
      items: [
        { to: '/home', icon: <HomeIcon />, label: t('sidebar.home') },
        { to: '/reservation', icon: <PlusIcon />, label: t('sidebar.newReservation') },
        { to: '/calendar', icon: <CalendarIcon />, label: t('sidebar.calendar') }
      ]
    },
    {
      group: 'sidebar.group.manage',
      items: [
        { to: '/generate-offer', icon: <SendIcon />, label: t('sidebar.generateOffer') },
        { to: '/clients', icon: <UsersIcon />, label: t('sidebar.clients') },
        { to: '/inventory', icon: <BoxIcon />, label: t('sidebar.inventory') },
        // Rejestr wpłat jest dla administratora (GET /api/payments bez rezerwacji daje pracownikowi 403);
        // pracownik widział pozycję, a strona pokazywała zera i „Brak uprawnień” (12.10.2026).
        ...(isAdmin ? [{ to: '/payments', icon: <BanknoteIcon />, label: t('sidebar.payments') }] : []),
        { to: '/statistics', icon: <ChartIcon />, label: t('sidebar.statistics') }
      ]
    },
    ...(isAdmin ? [{
      group: 'sidebar.group.tools',
      items: [
        { to: '/contract-template', icon: <DocumentIcon />, label: t('sidebar.contractTemplate') },
        { to: '/offer-template', icon: <TagIcon />, label: t('sidebar.offerTemplate') },
        { to: '/payment-settings', icon: <CreditCardIcon />, label: t('sidebar.paymentSettings') },
        { to: '/invoices', icon: <InvoiceIcon />, label: t('sidebar.invoices') },
        { to: '/notifications', icon: <BellIcon />, label: t('sidebar.notifications') },
        hasWidgetAccess
          ? { to: '/widget-media', icon: <CodeIcon />, label: t('sidebar.widget') }
          : { to: '/widget-media', locked: 'widget', icon: <CodeIcon />, label: t('sidebar.widget') }
      ]
    }] : []),
    {
      group: 'sidebar.group.account',
      items: [
        { to: '/profile', icon: <UserIcon />, label: t('sidebar.profile') },
        ...(isSuperAdmin ? [{ to: '/super-admin', icon: <SettingsIcon />, label: t('sidebar.superAdmin') }] : [])
      ]
    }
  ];

  return (
    <>
      {/* Hamburger, NIE strzalka. Ten przycisk OTWIERA menu, a dotad pokazywal chevron w lewo,
          czyli znak jednoznacznie czytany jako „wstecz", tym bardziej w trybie aplikacji, gdzie
          nie ma paska przegladarki i jest to jedyna strzalka na ekranie. Widac to bylo na
          zrzutach z telefonu: przycisk wyglada na powrot, a otwiera nawigacje. */}
      {isCollapsed && (
        <MobileToggleFab
          onClick={toggleSidebar}
          aria-label={t('sidebar.openMenu')}
          data-cy="sidebar-mobile-menu"
          data-ukryty={przyciskMenu.ukryty ? 'true' : undefined}
          data-nad-trescia={przyciskMenu.nadTrescia ? 'true' : undefined}
        >
          <MenuIcon />
        </MobileToggleFab>
      )}
      <MobileOverlay show={!isCollapsed} isCollapsed={isCollapsed} onClick={toggleSidebar} />
      <SidebarContainer isCollapsed={isCollapsed}>
        <SidebarHeader isCollapsed={isCollapsed}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%', gap: '12px' }}>
            <Logo isCollapsed={isCollapsed}>
              <LogoIcon src={logo} alt="the.rENT" />
              <LogoText>the.rENT</LogoText>
            </Logo>
          </div>

          {/* Dane organizacji i użytkownika */}
          <UserContextInfo isCollapsed={isCollapsed}>
            {organizationName && <OrganizationName title={organizationName}>{t('sidebar.organization')}: {organizationName}</OrganizationName>}
            {userFullName && <UserName title={userFullName}>{userFullName}</UserName>}
          </UserContextInfo>

          {/* Przycisk z sama ikona MUSI miec etykiete: bez niej czytnik ekranu oglasza go jako
              „przycisk" i tyle. Znalezione przy przegladzie kontrolek po regule dotykowej. */}
          <CollapseButton
            onClick={toggleSidebar}
            isCollapsed={isCollapsed}
            aria-label={isCollapsed ? t('sidebar.expandMenu') : t('sidebar.collapseMenu')}
            aria-expanded={!isCollapsed}
            title={isCollapsed ? t('sidebar.expandMenu') : t('sidebar.collapseMenu')}
          >
            <CollapseIcon />
          </CollapseButton>
        </SidebarHeader>

        {/* data-tour: kotwice przewodnika demo (components/DemoTour.js) — podświetlenie
            menu i konkretnych pozycji. Zmiana ścieżki `to` zmienia też selektor kroku. */}
        <NavSection data-tour="sidebar-nav">
          {navigationItems.map((group, groupIndex) => (
            <NavGroup key={groupIndex}>
              <NavGroupLabel isCollapsed={isCollapsed}>
                {t(group.group)}
              </NavGroupLabel>
              {group.items.map((item, itemIndex) => (item.locked ? (
                <NavLockedButton
                  key={itemIndex}
                  isCollapsed={isCollapsed}
                  data-cy={`nav-locked-${item.locked}`}
                  aria-label={`${item.label}: ${t('premium.badgeTitle')}`}
                  onClick={() => {
                    if (window.innerWidth <= 768) setIsCollapsed(true);
                    if (otworzChcePremium) otworzChcePremium(item.locked);
                  }}
                >
                  <NavIcon isCollapsed={isCollapsed}>
                    {item.icon}
                  </NavIcon>
                  <NavText isCollapsed={isCollapsed}>
                    {item.label}
                  </NavText>
                  <NavBadgeSlot isCollapsed={isCollapsed}>
                    <PremiumBadge data-cy="nav-premium-badge" />
                  </NavBadgeSlot>
                  <Tooltip isCollapsed={isCollapsed}>
                    {item.label} · {t('premium.badge')}
                  </Tooltip>
                </NavLockedButton>
              ) : (
                <NavItem
                  key={itemIndex}
                  to={item.to}
                  data-tour={`nav:${item.to}`}
                  isCollapsed={isCollapsed}
                  onClick={() => {
                    // Auto-zamykaj sidebar na mobile po kliknięciu linku
                    if (window.innerWidth <= 768) {
                      setIsCollapsed(true);
                    }
                  }}
                >
                  <NavIcon isCollapsed={isCollapsed}>
                    {item.icon}
                  </NavIcon>
                  <NavText isCollapsed={isCollapsed}>
                    {item.label}
                  </NavText>
                  <Tooltip isCollapsed={isCollapsed}>
                    {item.label}
                  </Tooltip>
                </NavItem>
              )))}
            </NavGroup>
          ))}
        </NavSection>

        <SidebarFooter>
          <LogoutButton onClick={logout} isCollapsed={isCollapsed} aria-label={t('sidebar.logout')} title={t('sidebar.logout')}>
            <LogoutIconContainer isCollapsed={isCollapsed}>
              <LogoutIconSVG />
            </LogoutIconContainer>
            <LogoutText isCollapsed={isCollapsed}>{t('sidebar.logout')}</LogoutText>
            <LogoutTooltip isCollapsed={isCollapsed}>{t('sidebar.logout')}</LogoutTooltip>
          </LogoutButton>
        </SidebarFooter>
      </SidebarContainer>
    </>
  );
}